import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

export const loginRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.token()) {
    return true;
  }

  if (authService.isAuthenticated()) {
    const homePath = authService.getHomePath();
    if (homePath !== '/login') {
      return router.createUrlTree([homePath]);
    }

    authService.clearSession();
    return true;
  }

  return authService.validateSession().pipe(
    map((isValidSession) => {
      if (isValidSession) {
        const homePath = authService.getHomePath();
        if (homePath !== '/login') {
          return router.createUrlTree([homePath]);
        }

        authService.clearSession();
      }

      return true;
    }),
  );
};
